import ReactDOM from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import { queryClient } from './lib/query'
// 导入全局样式
import './styles/globals.css'
import './index.css'
import './styles/modal-theme.css'
import App from './App'
import './i18n' // 导入 i18n 配置

// 🆕 SSO 启动性能优化 (Optimistic Boot)
import { performOptimisticRestore } from './stores/authStore';
import { getUserManager } from './features/auth/utils/oidcConfig';

// 1. 立即尝试从本地 Token 乐观恢复用户状态 (首帧渲染)
performOptimisticRestore();

// 2. 提前开始 OIDC 元数据预取 (后台并行)
if (import.meta.env.VITE_SKIP_SSO !== 'true') {
  getUserManager();
}

// ==================== 全局调试函数 ====================
// 在手机浏览器控制台或VConsole中可直接调用
import { forceCleanAndReload, debugAuthStorage, cleanAllAuthStorage } from './features/auth/utils/storageUtils';

// 导出到window对象，方便调试
if (typeof window !== 'undefined') {
  (window as any).__Vinka_DEBUG__ = {
    forceCleanAndReload,    // 清除缓存并刷新: window.__Vinka_DEBUG__.forceCleanAndReload()
    debugAuthStorage,       // 查看认证存储: window.__Vinka_DEBUG__.debugAuthStorage()
    cleanAllAuthStorage,    // 仅清除不刷新: window.__Vinka_DEBUG__.cleanAllAuthStorage()
    copyLogs: () => {       // 复制日志: window.__Vinka_DEBUG__.copyLogs()
      if ((window as any).__Vinka_COPY_LOGS__) {
        (window as any).__Vinka_COPY_LOGS__();
      } else {
        alert('⚠️ VConsole未启用，无法复制日志\n请在master环境或添加?debug=true访问');
      }
    }
  };

}
// ========================================================

ReactDOM.createRoot(document.getElementById('root')!).render(
  // 移除StrictMode，避免开发环境下的双重渲染和副作用
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>
) 
